"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskExecutionRequestDTOSchema = exports.TaskExecutionDTO = exports.TaskExecutionDTOSchema = exports.TaskExecutionSchema = exports.TaskExecutionBaseSchema = exports.TaskExecutionResultSchema = exports.TASK_EXECUTION_STATUS = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var TASK_EXECUTION_STATUS;
(function (TASK_EXECUTION_STATUS) {
    TASK_EXECUTION_STATUS["RUNNING"] = "running";
    TASK_EXECUTION_STATUS["SUCCESS"] = "success";
    TASK_EXECUTION_STATUS["ERROR"] = "error";
    TASK_EXECUTION_STATUS["SKIPPED"] = "skipped";
})(TASK_EXECUTION_STATUS || (exports.TASK_EXECUTION_STATUS = TASK_EXECUTION_STATUS = {}));
exports.TaskExecutionResultSchema = zod_1.z
    .object({
    emailsSent: zod_1.z.number().optional(), // Number of emails sent
    usersProcessed: zod_1.z.number().optional(), // Number of users processed
    usersDeactivated: zod_1.z.number().optional(), // Number of users deactivated
    usersActivated: zod_1.z.number().optional(), // Number of users activated
    paymentsProcessed: zod_1.z.number().optional(), // Number of payments processed
    notificationsSent: zod_1.z.number().optional(), // Number of notifications sent
    recordsUpdated: zod_1.z.number().optional(), // Number of records updated
    error: zod_1.z.string().optional(), // Error message if failed
    details: zod_1.z.any().optional(), // Additional execution details
})
    .passthrough(); // Allow additional fields not in schema
exports.TaskExecutionBaseSchema = zod_1.z.object({
    taskId: zod_1.z.instanceof(ObjectId_1.ObjectId).nullable(), // Reference to ScheduledTask (can be null for legacy executions)
    startTime: zod_1.z.coerce.date(), // When execution started
    endTime: zod_1.z.coerce.date().optional(), // When execution finished
    status: zod_1.z.nativeEnum(TASK_EXECUTION_STATUS),
    result: exports.TaskExecutionResultSchema.optional(),
    duration: zod_1.z.number().optional(), // Execution time in milliseconds
});
exports.TaskExecutionSchema = exports.TaskExecutionBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.TaskExecutionDTOSchema = exports.TaskExecutionSchema.extend(CommonMongoModelFields_1.CommonModelDTOFields).extend({
    taskId: zod_1.z.string(),
});
exports.TaskExecutionDTO = {
    convertFromModel: function (model) {
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            taskId: model.taskId ? model.taskId.toString() : '', // Handle null taskId safely
            startTime: model.startTime,
            endTime: model.endTime,
            status: model.status,
            result: model.result,
            duration: model.duration,
        };
        return dto;
    },
    // Special conversion for dashboard that preserves populated task info
    convertFromModelWithTask: function (model) {
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            taskId: model.taskId && typeof model.taskId === 'object' && model.taskId._id
                ? {
                    _id: model.taskId._id.toString(),
                    name: model.taskId.name,
                    slug: model.taskId.slug,
                }
                : model.taskId
                    ? model.taskId.toString()
                    : '',
            startTime: model.startTime,
            endTime: model.endTime,
            status: model.status,
            result: model.result,
            duration: model.duration,
        };
        return dto;
    },
};
exports.TaskExecutionRequestDTOSchema = exports.TaskExecutionDTOSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelRequestDTOFields), { taskId: (0, ObjectId_1.ObjectIdString)('Invalid task id') }));
//# sourceMappingURL=TaskExecution.js.map